import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import * as api from '../services/api.js'

const COOKIE_NAME = 'analytics_consent'
const LS_KEY = 'analytics_consent'

function getStoredConsent() {
  try {
    return localStorage.getItem(LS_KEY)
  } catch {
    return null
  }
}

function setConsent(value) {
  try {
    localStorage.setItem(LS_KEY, value)
    document.cookie = `${COOKIE_NAME}=${value};path=/;max-age=${365 * 24 * 60 * 60};SameSite=Lax`
  } catch {
    // storage unavailable
  }
}

function getUserId() {
  try {
    const u = JSON.parse(localStorage.getItem('user'))
    return u?.objectId || null
  } catch {
    return null
  }
}

function saveConsentToUser(consent) {
  const userId = getUserId()
  if (!userId) return
  api.updateUserPreferences(userId, { analyticsConsent: consent }).catch(() => {})
}

export default function AnalyticsConsent() {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!getStoredConsent()) {
      setVisible(true)
    }
  }, [])

  function handleAccept() {
    setConsent('accepted')
    saveConsentToUser('accepted')
    setVisible(false)
  }

  function handleReject() {
    setConsent('rejected')
    saveConsentToUser('rejected')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      backgroundColor: '#1a1a2e',
      borderTop: '1px solid #333',
      padding: '1rem 1.5rem',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1rem',
      boxShadow: '0 -4px 20px rgba(0,0,0,0.3)',
      animation: 'slideUp 0.3s ease-out',
    }}>
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
      <p style={{
        flex: '1 1 300px',
        margin: 0,
        color: '#e0e0e0',
        fontSize: '0.875rem',
        lineHeight: 1.5,
      }}>
        {t('cookieConsent.message')}{' '}
        <a
          href="/page/privacy-policy"
          style={{ color: '#0ea5e9', textDecoration: 'underline' }}
          onClick={(e) => { e.stopPropagation() }}
        >
          {t('cookieConsent.learnMore')}
        </a>
      </p>
      <div style={{ display: 'flex', gap: '0.75rem', flexShrink: 0 }}>
        <button
          onClick={handleReject}
          style={{
            padding: '0.5rem 1.25rem',
            borderRadius: '6px',
            border: '1px solid #555',
            backgroundColor: 'transparent',
            color: '#999',
            cursor: 'pointer',
            fontSize: '0.875rem',
            transition: 'all 0.2s',
          }}
          onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#2a2a3e' }}
          onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent' }}
        >
          {t('cookieConsent.reject')}
        </button>
        <button
          onClick={handleAccept}
          style={{
            padding: '0.5rem 1.25rem',
            borderRadius: '6px',
            border: 'none',
            backgroundColor: 'var(--primary, #0ea5e9)',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: 600,
            transition: 'opacity 0.2s',
          }}
          onMouseEnter={e => { e.currentTarget.style.opacity = '0.85' }}
          onMouseLeave={e => { e.currentTarget.style.opacity = '1' }}
        >
          {t('cookieConsent.accept')}
        </button>
      </div>
    </div>
  )
}